import { Fragment, useMemo } from "react";
import { Menu, Transition } from "@headlessui/react";

import DisclosuresRenderButton from "./DisclosuresRenderButton";
import DisclosuresMenuItem from "./DisclosuresMenuItem";

import Loader from "~/ui/Loader";
import useInitDisclosuresList from "~/features/SearchV3/hooks/useInitDisclosuresList";

interface DisclosuresListProps {
    className?: string;
}

/** This disclosures menu fetches the Disclosures data before displaying it */
const DisclosuresList = ({ className }: DisclosuresListProps) => {
    const {
        fullDisclosuresList,
        disclosure,
        disclosureName,
        isLoading,
        isFetching,
        language,
        handleDisclosureClick
    } = useInitDisclosuresList();

    const isLocked = isLoading || isFetching;

    const listItems = useMemo(() => {
        return fullDisclosuresList.map(item => {
            const isSelected = item.id === disclosure?.id;

            return (
                <DisclosuresMenuItem
                    key={item.id}
                    disclosure={item}
                    isSelected={isSelected}
                    btnClickCallback={handleDisclosureClick}
                />
            );
        });
    }, [language, fullDisclosuresList, disclosure]);

    return (
        <Menu as="div" className="relative inline-block">
            <Menu.Button className="focus:outline-none" disabled={isLocked}>
                {({ open }) => (
                    <DisclosuresRenderButton
                        open={open}
                        disclosureName={disclosureName}
                        className={className}
                    />
                )}
            </Menu.Button>

            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items className="absolute mt-2 w-56 origin-top-right border border-[rgba(166, 160, 155, 0.20)] rounded-md bg-white !shadow-md focus:outline-none">
                    <div className="px-1 py-1">
                        {isLocked ? <Loader className="scale-50" /> : listItems}
                    </div>
                </Menu.Items>
            </Transition>
        </Menu>
    );
};

export default DisclosuresList;
